import axiosInstance from 'src/utils/axiosConfig';

export const getUserDetails = async () => {
   return axiosInstance.get('/api/user');
};

let cachedUserDetails: any = null;

export const getCachedUserDetails = async () => {
    if (!cachedUserDetails) {
        const response = await axiosInstance.get('/api/user');
        cachedUserDetails = response.data;
    }
    return cachedUserDetails;
};
